import { render } from "./ScoreboardPhoneticConsonant.vue?vue&type=template&id=d6f7c774&scoped=true"
import script from "./ScoreboardPhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./ScoreboardPhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/scoreboard-phonetic-consonant.css?vue&type=style&index=0&id=d6f7c774&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f7c774"]])

export default __exports__